import { useTranslation } from "react-i18next";
import { Button } from "antd";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";
// import PdfViewer from "logic/src/components/PdfViewer";
import FileDisplay from "logic/src/objects/file/components/FileDisplay";

const list = [
  {
    id: "1",
    "text": "取时间：上午 9:00-12:00\n下午 13:00-18:00\n⚫ 领取地点：",
    "startPage": 1,
    "startId": "1-10",
    "startOffset": 1,
    "endPage": 1,
    "endId": "1-28",
    "endOffset": 1,
    "top": 469.71875,
    "left": 92.046875,
    "right": 326.4078369140625,
    "bottom": 552.21875,
    "width": 234.3609619140625,
    "height": 82.5,
    "mouseX": 192,
    "mouseY": 546,
  },
  {
    id: "12",
    "text": "需申领口",
    "startPage": 1,
    "startId": "1-2",
    "startOffset": 3,
    "endPage": 1,
    "endId": "1-2",
    "endOffset": 7,
    "top": 260.796875,
    "left": 358.10992431640625,
    "right": 470.5220947265625,
    "bottom": 300.796875,
    "width": 112.41217041015625,
    "height": 40,
    "mouseX": 484,
    "mouseY": 272,
  },
  {
    id: "14",
    "text": "上海市徐汇区",
    "startPage": 2,
    "startId": "2-3",
    "startOffset": 0,
    "endPage": 2,
    "endId": "2-3",
    "endOffset": 6,
    "top": 257,
    "left": 299.9375,
    "right": 419.46875,
    "bottom": 285,
    "width": 119.53125,
    "height": 28,
    "mouseX": 411,
    "mouseY": 270,
  },

  {
    id: "16",
    "text":
      "：所在大厦前台\n⚫ 企业微信-工作台-行政之窗-口罩申领-选择所在职场-提交申请\n关于商汤科技大厦\n地址：上海",
    "startPage": 1,
    "startId": "1-34",
    "startOffset": 6,
    "endPage": 2,
    "endId": "2-3",
    "endOffset": 2,
    "top": -324,
    "left": 0,
    "right": 960,
    "bottom": 756,
    "width": 960,
    "height": 1080,
    "mouseX": 331,
    "mouseY": 371,
  },
];

let indexTest = 0;

const Test = () => {
  const { t } = useTranslation();
  const [selection, setSelection] = useState<any>();

  const handleTest = async () => {
    // const token = await crossStorageClient.getItem('token')
    // console.log('token', token)
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     throw Error("eeeerrrrrr");
  //   }, 2000);
  // }, []);
  return null;
};

export default Test;
